import { render } from "./editParagraph.vue?vue&type=template&id=0afb95b6"
import script from "./editParagraph.vue?vue&type=script&lang=js"
export * from "./editParagraph.vue?vue&type=script&lang=js"

import "./editParagraph.vue?vue&type=style&index=0&id=0afb95b6&lang=css"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__